// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__rFsbR","header":"Messages_header__dtEbj"};